import React, { useEffect, useState } from "react";
import api from "../axiosConfig";
import { Link } from "react-router-dom";
import {
  Container,
  Table,
  Button,
  Row,
  Col,
  Form,
  InputGroup,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import { format, parseISO } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";

function InvoiceList() {
  const [invoices, setInvoices] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [searchClient, setSearchClient] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    api
      .get("/invoices")
      .then((res) => {
        setInvoices(res.data);
        setFiltered(res.data);
      })
      .catch((err) => console.error(err));
  }, []);
  useEffect(() => {
    const filteredList = invoices.filter((inv) => {
      const clientName = inv.client?.bxdenumire || "";
      const clientMatch = clientName
        .toLowerCase()
        .includes(searchClient.toLowerCase());

      const invoiceDate = parseISO(inv.date);

      const dateMatch =
        (!startDate || invoiceDate >= startDate) &&
        (!endDate || invoiceDate <= endDate);

      return clientMatch && dateMatch;
    });

    setFiltered(filteredList);
  }, [searchClient, startDate, endDate, invoices]);

  const clearFilters = () => {
    setSearchClient("");
    setStartDate(null);
    setEndDate(null);
  };

  return (
    <Container className="mt-4">
      <Row className="mb-3 align-items-center">
        <Col>
          <h3>Lista Facturi</h3>
        </Col>
        <Col className="text-end">
          <Link to="/createinvoice">
            <Button variant="primary">+ Adaugă Factură</Button>
          </Link>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={4}>
          <InputGroup>
            <InputGroup.Text>Client</InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Caută după client"
              value={searchClient}
              onChange={(e) => setSearchClient(e.target.value)}
            />
          </InputGroup>
        </Col>

        <Col md={3}>
          <InputGroup>
            <InputGroup.Text>De la</InputGroup.Text>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              dateFormat="dd.MM.yyyy"
              className="form-control"
              placeholderText="Start"
              isClearable
            />
          </InputGroup>
        </Col>

        <Col md={3}>
          <InputGroup>
            <InputGroup.Text>Până la</InputGroup.Text>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              dateFormat="dd.MM.yyyy"
              className="form-control"
              placeholderText="End"
              isClearable
            />
          </InputGroup>
        </Col>

        <Col md={2} className="text-end">
          <Button variant="outline-secondary" onClick={clearFilters}>
            Clear filtre
          </Button>
        </Col>
      </Row>

      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>ID</th>
            <th>Client</th>
            <th>Data</th>
            <th>Scadență</th>
            <th>Total</th>
            <th>Acțiuni</th> {/* nou */}
          </tr>
        </thead>
        <tbody>
          {filtered.map((inv) => (
            <tr key={inv.id}>
              <td>{inv.id}</td>
              <td>{inv.client?.bxdenumire || `ID ${inv.client_id}`}</td>
              <td>{format(parseISO(inv.date), "dd.MM.yyyy")}</td>
              <td>{format(parseISO(inv.due_date), "dd.MM.yyyy")}</td>
              <td>{inv.total}</td>
              <td>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => navigate(`/editinvoice/${inv.id}`)}
                >
                  Editare
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
}

export default InvoiceList;
